var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-container actions--container"},[_c('resolve-action',{attrs:{"conversation-id":_vm.currentChat.id,"status":_vm.currentChat.status}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }